<script lang="ts">
    import { cn } from "../cn";
    let className = "";
    export { className as class };
</script>

<div
    class={cn(
        "bg-[var(--card)] text-[var(--card-foreground)] flex flex-col gap-6 rounded-2xl border border-t-2 border-t-[color-mix(in_oklch,var(--primary)_15%,transparent)] py-6 shadow-sm",
        className,
    )}
>
    <slot />
</div>
